import React from "react";
import { Toaster } from "react-hot-toast";
import "./src/style/global.css";

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <Toaster position="top-right" />
  </>
);
